module.exports = __webpack_public_path__ + "img/calendar-white.923f982b.svg";